import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin, setAdminToken } from "../../api";
import { Lock } from "lucide-react";
import Logo from "../../components/Logo";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const res = await adminLogin(email.trim().toLowerCase(), password);
      setAdminToken(res.token);
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6 bg-[#050505]"
      data-testid="admin-login-page"
    >
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md bg-[#0d0d0d] border border-white/10 p-10"
        data-testid="admin-login-form"
      >
        <Logo size="md" />
        <div className="mt-8 mb-2 inline-flex items-center gap-2 text-[#FFB400] text-label">
          <Lock size={12} /> Admin access
        </div>
        <h1 className="font-heading text-3xl font-bold text-white tracking-tight">
          Sign in to dashboard
        </h1>

        <div className="mt-8 space-y-5">
          <div>
            <label className="text-label block mb-2">Email</label>
            <input
              type="email"
              className="movix-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email"
              autoComplete="email"
              required
            />
          </div>
          <div>
            <label className="text-label block mb-2">Password</label>
            <input
              type="password"
              className="movix-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
              autoComplete="current-password"
              required
            />
          </div>
        </div>

        {error && (
          <p
            className="mt-4 text-sm text-red-400 border border-red-500/30 bg-red-500/10 p-3"
            data-testid="admin-login-error"
          >
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={submitting}
          className="btn-primary w-full justify-center mt-6 disabled:opacity-60"
          data-testid="admin-login-submit"
        >
          {submitting ? "Signing in…" : "Sign in"}
        </button>

        <p className="mt-8 text-xs text-zinc-500 leading-relaxed">
          This area is for Movix staff only. Customer reservations and
          referrals are visible here.
        </p>
      </form>
    </div>
  );
};

export default Login;
